<template>
  <div>
    <div
      v-if="loading"
      class="text-center"
      :style="styleObject"
    >
      <v-icon
        light
        class="custom-loader"
        :style="styleObject"
      >
        mdi-cached
      </v-icon>
      Carregando Dados...
    </div>
    <div
      v-else-if="error"
      class="alert alert-danger"
    >
      {{ error }}
    </div>
    <div
      id="totalDevolucaoImpropriaFaturadosVendedor"
      class="text-center"
    >
      <canvas
        id="myChartDevolucaoImpropriaFaturadosVendedor"
        width="70"
        height="50"
      />
      <div
        v-if="exibirLegenda"
        id="valorDevPerce"
        class="text-center"
      >
        {{ porcentagem }}
      </div>
      <div
        v-if="exibirLegenda"
        id="valorMinimoOrcado"
      >
        {{ valorMinimoOrcado }}
      </div>
      <div
        v-if="exibirLegenda"
        id="valorMaximoOrcado"
      >
        {{ valorMaximoOrcado }}
      </div>
    </div>
  </div>
</template>

<script>
  import Chart from 'chart.js'
  import Comercial from '../../../../services/comercialpersonalizacao'
  import eventEmit from '../../components/core/EventoEmit'

  export default {
    name: 'DashboardFaturamentoPrecoMedio',
    emits: ['enableBtnPrint'],
    components: {
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      styleObjectPorcentagem: {
        color: '#E53935',
      },
      cores: [],
      myChart: {},
      selectResumo: [],
      selectMes: [],
      selectAno: [],
      selectVendedor: [],
      selectSupervisor: [],
      porcentagem: 0,
      valorMaximoOrcado: parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%',
      valorMinimoOrcado: parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%',
      exibirLegenda: false,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      montarGrafico: true,
      loading: false,
      error: null,
    }),

    created () {
      eventEmit.$on('set-update-filtros', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('set-update-filtros', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (selectVendedor, selectResumo, selectMes, selectAno, selectSupervisor) {
        this.selectVendedor = selectVendedor
        this.selectResumo = selectResumo
        this.selectMes = selectMes
        this.selectAno = selectAno
        this.selectSupervisor = selectSupervisor

        this.porcentagem = 0
        this.valorMaximoOrcado = parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%'
        this.valorMinimoOrcado = parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%'

        this.atualizaDados()
      },

      async atualizaDados () {
        this.loading = true

        if (this.myChart.data) {
          this.myChart.destroy()
        }

        await Comercial.showFaturamentoDevolucaoImpropriaVendedor(this.selectVendedor, this.selectResumo, this.selectMes, this.selectAno, this.selectSupervisor, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.exibirLegenda = true

            this.porcentagem = resposta.data.devolucao + '%'

            this.valorMaximoOrcado = resposta.data.orcado + '%'

            const ctx = document.getElementById('myChartDevolucaoImpropriaFaturadosVendedor').getContext('2d')

            this.myChart = new Chart(ctx, {
              type: 'doughnut',
              data: {
                labels: ['Devolucao', 'Orçado'],
                datasets: [
                  {
                    label: 'Devolução',
                    data: [resposta.data.porcentagem, resposta.data.restante],
                    backgroundColor: ['#EF5350', '#FFEBEE'],
                  },
                ],
              },
              options: {
                legend: {
                  display: false,
                },
                responsive: true,
                circumference: 3.1,
                rotation: 3.15,
                cutoutPercentage: 70,
                tooltips: {
                  enabled: false,
                },
              },
            })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          eventEmit.$emit('enable-btn-print', true)

          this.loading = false
        })
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style scoped>
  @media only screen
  and (min-device-width : 320px)
  and (max-device-width : 600px) {
    #myChartDevolucaoImpropriaFaturadosVendedor {
      display: block;
      width: 142px !important;
      height: 100px !important;
      margin: -3rem 0 0 6rem !important;
    }

    #valorMinimoOrcado {
      margin: 0.3rem 0 0 -12rem !important;
      font-size: 18px;
    }

    #valorMaximoOrcado {
      margin: -2.0rem 0 0 5rem !important;
      font-size: 18px;
    }

    #valorDevPerce {
      margin: -3.5rem 0 0 -4rem !important;
      font-size: 18px;
    }
  }

  @media only screen
  and (min-device-width : 601px)
  and (max-device-width : 1000px) {
    #myChartDevolucaoImpropriaFaturadosVendedor {
      display: block;
      width: 185px !important;
      height: 128px !important;
      margin: -2rem 0 0 24rem !important;
    }

    #valorMinimoOrcado {
      margin: 0.9rem 0 0 -10rem !important;
      font-size: 18px;
    }

    #valorMaximoOrcado {
      margin: -2.1rem 0 0 12rem !important;
      font-size: 18px;
    }

    #valorDevPerce {
      margin: -4rem 0 0 1rem !important;
      font-size: 18px;
    }
  }

  @media screen
  and (min-width: 1380px) {
    #valorMinimoOrcado {
      margin: 0.9rem 0 0 -19rem !important;
    }

    #valorMaximoOrcado {
      margin: -2.1rem 0 0 8rem !important;
    }

    #valorDevPerce {
      margin: -5rem 0 0 -6rem !important;
    }
  }
</style>

<style lang="sass">
  #myChartDevolucaoImpropriaFaturadosVendedor
    font-size: 20px
    display: grid
    align-items: center
    font-weight: bold
    margin: -3rem 0 0 4rem
    width: 230px !important
    height: 160px !important

  #totalDevolucaoImpropriaFaturadosVendedor
    margin: 2rem 0 0 0
    font-size: 20px
    align-items: center
    font-weight: bold

  #valorDevPerce
    margin: -5rem 0 0 4rem

  #valorMinimoOrcado
    margin: 1rem 0 0 -10rem

  #valorMaximoOrcado
    margin: -2.15rem 0 0 17.5rem

  .custom-loader
    animation: loader 1s infinite
    display: flex
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
</style>
